/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 18/12/2020
 */
import BaseObject from "@shared/BaseObject";

export default class Migration extends BaseObject {

	startVersion: number = null
	endVersion: number = null
	migrateFn


	constructor(startVersion: number, endVersion: number, migrateFn) {
		super();
		if(endVersion - startVersion !== 1){
			throw new Error("Migration can only be performed for sequential versions (e.g. 1 -> 2, 2 -> 3 etc.)")
		}
		this.startVersion = startVersion;
		this.endVersion = endVersion;
		this.migrateFn = migrateFn
	}

	async migrate(dataManager, dataItem){
		return await this.migrateFn(dataManager, dataItem)
	}
}
